import React, { useState } from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "../styles/ContactPage.css";

const ContactPage = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.name && form.email && form.message) {
      alert(`Thanks ${form.name}, your message has been sent! 🚴`);
      setForm({ name: "", email: "", message: "" });
    } else {
      alert("Please fill in all fields.");
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-header">
        <h1>Contact <span>Us</span></h1>
        <p>We’d love to hear from you! Get in touch for queries, collaborations, or feedback.</p>
      </div>

      <div className="contact-container">
        {/* Left Section: Contact Info */}
        <div className="contact-info">
          <h2>Get In Touch</h2>
          <p>Reach us via any of the following ways:</p>
          <ul>
            <li><FaPhoneAlt /> +91 6396353776</li>
            <li><FaEnvelope /> support@sacmtb.com</li>
            <li><FaMapMarkerAlt /> Meerut, Uttar Pradesh, India</li>
          </ul>
          <iframe
            title="SAC MTB Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.909555159978!2d77.700012!3d28.984462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390c65b16d9a4b25%3A0x86d6b4c7a079c46a!2sMeerut%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1685102134567!5m2!1sen!2sin"
            width="100%"
            height="200"
            style={{ border: 0, borderRadius: "10px" }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

        {/* Right Section: Contact Form */}
        <div className="contact-form">
          <h2>Send Us a Message</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={form.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={form.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={form.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
